import { render } from "./ModalConfirmation.vue?vue&type=template&id=4d1e07a4&scoped=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=4d1e07a4&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1e07a4"]])

export default __exports__